import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	bannerCardContainer: {
		position: "relative",
		flex: "1 1 100%",
		width: "100%",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	bannerImg: {
		width: "100%",
		height: "100%",
		objectFit: "cover",
		maxWidth: "100%"
	},
	dotsContainer: {
		position: "absolute",
		bottom: "2%",
		left: "50%",
		transform: "translateX(-50%)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "5px",
		zIndex: 1
	},
	dot: {
		appearance: "none",
		touchAction: "manipulation",
		display: "inline-flex",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		opacity: 0.5,
		textDecoration: "none",
		border: "0",
		padding: "0",
		margin: "0",
		width: "10px",
		height: "10px",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "50%",
		cursor: "pointer"
	},
	dotActive: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		opacity: 1
	}
})

export default useStyles
